var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-wiki-side-msg"},[_c('RightSideMsg',[_c('em',[_vm._v("魔盒成就群")]),_vm._v(" : "),_c('strong',[_c('a',{attrs:{"href":"https://jq.qq.com/?_wv=1027&k=5S50j08"}},[_vm._v(_vm._s(_vm.qq))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }